/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import BaseCom from "../BaseCom";
import L from "../Lang";
import { TabsNav, TabsNavItem } from "../TabsNav";

export default class CompendiumTabs extends BaseCom {
    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        return <TabsNav>
            <TabsNavItem to="/productline/list" title={<L>Product Lines</L>} />
            <TabsNavItem to="/panel/manage/list" title={<L>Panels</L>} />
            <TabsNavItem to="/target/manage/list" title={<L>Targets</L>} />
        </TabsNav>;
    }
}
